export default __webpack_public_path__ + "static/media/avatar-img01.05a78709.png";